export default __webpack_public_path__ + "static/media/colony2.0e4ebdb2.jpg";